export const ROLES = {
  ATTORNEY: "attorney",
  PARALEGAL: "paralegal",
  MEMBER: "member",
  SECTRETARY: "secretary",
  ADMIN: "admin",
  OWNER: "owner",
};

export const ROLES_ARRAY = [
  { title: "Attorney", value: ROLES.ATTORNEY },
  { title: "Paralegal", value: ROLES.PARALEGAL },
  { title: "Secretary", value: ROLES.SECTRETARY },
  { title: "Member", value: ROLES.MEMBER },
  { title: "Admin", value: ROLES.OWNER },
];

export const UPDATE_FREQUENCIES = {
  DAILY: "daily",
  WEEKDAYS: "weekdays",
  EVERY_OTHER_DAY: "every_other_day",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  NEVER: "never",
};

export const INTERVALS = [
  { name: "Daily", value: UPDATE_FREQUENCIES.DAILY },
  { name: "Weekdays", value: UPDATE_FREQUENCIES.WEEKDAYS },
  { name: "Every Other Day", value: UPDATE_FREQUENCIES.EVERY_OTHER_DAY },
  { name: "Weekly", value: UPDATE_FREQUENCIES.WEEKLY },
  { name: "Monthly", value: UPDATE_FREQUENCIES.MONTHLY },
  { name: "Never", value: UPDATE_FREQUENCIES.NEVER },
];

export const SCHEDULES: { [key: string]: string } = {
  [UPDATE_FREQUENCIES.DAILY]: "Daily",
  [UPDATE_FREQUENCIES.WEEKDAYS]: "Weekdays",
  [UPDATE_FREQUENCIES.EVERY_OTHER_DAY]: "Every Other Day",
  [UPDATE_FREQUENCIES.WEEKLY]: "Weekly",
  [UPDATE_FREQUENCIES.MONTHLY]: "Monthly",
  [UPDATE_FREQUENCIES.NEVER]: "Never",
};
